import Tmdb from "../../services/tmdb";

const tmdb = new Tmdb();

export const FETCH_PLAYING_REQUESTED = "FETCH_PLAYING_REQUESTED";
export const PLAYING_LOADED = "PLAYING_LOADED";
export const PLAYING_ERROR = "PLAYING_LOADED";
export const LOAD_MORE_REQUESTED = "LOAD_MORE_REQUESTED";
export const LOAD_MORE = "LOAD_MORE";

export const playingRequested = () => {
  return {
    type: FETCH_PLAYING_REQUESTED
  };
};

export const playingLoaded = movies => {
  return {
    type: PLAYING_LOADED,
    payload: movies
  };
};

export const playingMoreLoaded = movies => {
  return {
    type: LOAD_MORE,
    payload: movies
  };
};

export const moreLoadRequested = () => {
  return {
    type: LOAD_MORE_REQUESTED
  };
};

export const playingError = () => {
  return {
    type: PLAYING_ERROR
  };
};

export const loadMore = page => {
  return dispatch => {
    dispatch(moreLoadRequested());
    tmdb
      .getPlayingMovies(page)
      .then(data => dispatch(playingMoreLoaded(data)))
      .catch(() => dispatch(playingError()));
  };
};

export const fetchPlayingMovies = page => {
  return dispatch => {
    dispatch(playingRequested());
    tmdb
      .getPlayingMovies(page)
      .then(data => dispatch(playingLoaded(data)))
      .catch(() => dispatch(playingError()));
  };
};
